<template>
  <div>
    <v-row style="" no-gutters>
      <v-col
        cols="12"
        sm="12"
        style="padding: 20px;"
      >
        <center>
          <search :onSearch="handleGetData" maxWidth="1000"/> {{results.length}}
        </center>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        style="padding: 5px;"
      >
        <v-row style="" no-gutters
          v-for="(item, index) of results"
          :key="index"
          :style="{'background-color': index%2 === 0 ? '#CCCCCC80' : '#CCCCCC'}"
        >
          <v-col
            cols="12"
            sm=3
          >
            {{item.T}}
          </v-col>
          <v-col
            cols="12"
            sm=3
          >
            {{item.C}}
          </v-col>
          <v-col
            cols="12"
            sm=6
          >
            {{item.D}}
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import api from '@/services/api'
import Search from '@/components/Search'
export default {
  components: {
    Search,
  },
  data: () => ({
    results: [],
  }),
  methods: {
    async handleGetData (v) {
      try {
        this.results = []
        if (!v) return
        this.results = await new Promise((resolve) => api.put('dtouch', `v1/public/system/file-search`, { search: v})
          .then((response) => {
            resolve(response.data)
          }))
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>

